export var IconsList = {
    'add-folder': {
        src: require('./img/add-folder.svg'),
        width: '20px',
        height: '16px',
    },
    'add-to-list': {
        src: require('./img/add-to-list.svg'),
        width: '16px',
        height: '16px',
    },
    'add-user': {
        src: require('./img/add-user.svg'),
        width: '18px',
        height: '12px',
    },
    'align-bottom': {
        src: require('./img/align-bottom.svg'),
        width: '20px',
        height: '18px',
    },
    'align-left': {
        src: require('./img/align-left.svg'),
        width: '18px',
        height: '20px',
    },
    'align-right': {
        src: require('./img/align-right.svg'),
        width: '18px',
        height: '20px',
    },
    'align-top': {
        src: require('./img/align-top.svg'),
        width: '20px',
        height: '18px',
    },
    'align-h-center': {
        src: require('./img/align-h-center.svg'),
        width: '14px',
        height: '20px',
    },
    'align-v-center': {
        src: require('./img/align-v-center.svg'),
        width: '20px',
        height: '14px',
    },
    'align-text-left': {
        src: require('./img/align-text-left.svg'),
        width: '20px',
        height: '18px',
    },
    'align-text-center': {
        src: require('./img/align-text-center.svg'),
        width: '20px',
        height: '18px',
    },
    'align-text-right': {
        src: require('./img/align-text-right.svg'),
        width: '20px',
        height: '18px',
    },
    'app': {
        src: require('./img/app.svg'),
        width: '16px',
        height: '16px',
    },
    'app-store': {
        src: require('./img/app-store.svg'),
        width: '20px',
        height: '20px',
    },
    'arrow-down': {
        src: require('./img/arrow-down.svg'),
        width: '16px',
        height: '16px',
    },
    'arrow-left': {
        src: require('./img/arrow-left.svg'),
        width: '10px',
        height: '16px',
    },
    'arrow-right': {
        src: require('./img/arrow-right.svg'),
        width: '10px',
        height: '16px',
    },
    'arrow-up': {
        src: require('./img/arrow-up.svg'),
        width: '10px',
        height: '16px',
    },
    'bulb': {
        src: require('./img/bulb.svg'),
        width: '20px',
        height: '20px',
    },
    'bulb-off': {
        src: require('./img/bulb-off.svg'),
        width: '20px',
        height: '20px',
    },
    'calendar': {
        src: require('./img/calendar.svg'),
        width: '16px',
        height: '16px',
    },
    'camera': {
        src: require('./img/camera.svg'),
        width: '16px',
        height: '16px',
    },
    'canvas-brush': {
        src: require('./img/canvas-brush.svg'),
        width: '20px',
        height: '20px',
    },
    'caret-down': {
        src: require('./img/caret-down.svg'),
        width: '16px',
        height: '10px',
    },
    'caret-down-mini': {
        src: require('./img/caret-down.svg'),
        width: '10px',
        height: '6px',
    },
    'caret-up': {
        src: require('./img/caret-up.svg'),
        width: '16px',
        height: '10px',
    },
    'casting': {
        src: require('./img/casting.svg'),
        width: '20px',
        height: '16px',
    },
    'channel': {
        src: require('./img/channel.svg'),
        width: '14px',
        height: '18px',
    },
    'checked-circle': {
        src: require('./img/checked-circle.svg'),
        width: '16px',
        height: '16px',
    },
    'circle': {
        src: require('./img/circle.svg'),
        width: '16px',
        height: '16px',
    },
    'circle-arrow-left': {
        src: require('./img/circle-arrow-left.svg'),
        width: '16px',
        height: '16px',
    },
    'circle-arrow-right': {
        src: require('./img/circle-arrow-right.svg'),
        width: '16px',
        height: '16px',
    },
    'clear-cache': {
        src: require('./img/clear-cache.svg'),
        width: '18px',
        height: '16px',
    },
    'clipboard': {
        src: require('./img/clipboard.svg'),
        width: '18px',
        height: '20px',
    },
    'clock': {
        src: require('./img/clock.svg'),
        width: '16px',
        height: '16px',
    },
    'close': {
        src: require('./img/close.svg'),
        width: '16px',
        height: '16px',
    },
    'create-playlist': {
        src: require('./img/create-playlist.svg'),
        width: '20px',
        height: '19px',
    },
    'disable-view': {
        src: require('./img/disable-view.svg'),
        width: '16px',
        height: '14px',
    },
    'document': {
        src: require('./img/document.svg'),
        width: '13px',
        height: '18px',
    },
    'dot': {
        src: require('./img/dot.svg'),
        width: '16px',
        height: '4px',
    },
    'download': {
        src: require('./img/download.svg'),
        width: '16px',
        height: '16px',
    },
    'drag': {
        src: require('./img/drag.svg'),
        width: '16px',
        height: '16px',
    },
    'duplicate': {
        src: require('./img/duplicate.svg'),
        width: '16px',
        height: '16px',
    },
    'edit': {
        src: require('./img/edit.svg'),
        width: '16px',
        height: '16px',
    },
    'edit-circle': {
        src: require('./img/edit-circle.svg'),
        width: '16px',
        height: '16px',
    },
    'email-add': {
        src: require('./img/email-add.svg'),
        width: '19.2px',
        height: '16px',
    },
    'email-cancel': {
        src: require('./img/email-cancel.svg'),
        width: '19px',
        height: '16px',
    },
    'email-resend': {
        src: require('./img/email-resend.svg'),
        width: '19px',
        height: '16px',
    },
    'email': {
        src: require('./img/email.svg'),
        width: '16px',
        height: '13px',
    },
    'enter-fullscreen': {
        src: require('./img/enter-fullscreen.svg'),
        width: '16px',
        height: '16px',
    },
    'exit-fullscreen': {
        src: require('./img/exit-fullscreen.svg'),
        width: '16px',
        height: '16px',
    },
    'expand': {
        src: require('./img/expand.svg'),
        width: '18px',
        height: '18px',
    },
    'external': {
        src: require('./img/external.svg'),
        width: '15px',
        height: '15px',
    },
    'grid': {
        src: require('./img/grid.svg'),
        width: '16px',
        height: '13px',
    },
    'groups': {
        src: require('./img/groups.svg'),
        width: '20px',
        height: '14px',
    },
    'groups-remove-default': {
        src: require('./img/groups-remove-default.svg'),
        width: '20px',
        height: '20px',
    },
    'help': {
        src: require('./img/help.svg'),
        width: '16px',
        height: '16px',
    },
    'home': {
        src: require('./img/home.svg'),
        width: '18px',
        height: '16px',
    },
    'image': {
        src: require('./img/image.svg'),
        width: '18px',
        height: '13px',
    },
    'info': {
        src: require('./img/info.svg'),
        width: '16px',
        height: '16px',
        cursor: 'help',
    },
    'layer-back': {
        src: require('./img/layer-back.svg'),
        width: '12px',
        height: '20px',
    },
    'layer-forward': {
        src: require('./img/layer-forward.svg'),
        width: '12px',
        height: '20px',
    },
    'layer-to-back': {
        src: require('./img/layer-to-back.svg'),
        width: '20px',
        height: '20px',
    },
    'layer-to-front': {
        src: require('./img/layer-to-front.svg'),
        width: '20px',
        height: '20px',
    },
    'link': {
        src: require('./img/link.svg'),
        width: '16px',
        height: '16px',
    },
    'list': {
        src: require('./img/list.svg'),
        width: '16px',
        height: '13px',
    },
    'lock': {
        src: require('./img/lock.svg'),
        width: '14px',
        height: '20px',
    },
    'logout': {
        src: require('./img/logout.svg'),
        width: '16px',
        height: '16px',
    },
    'magic': {
        src: require('./img/magic.svg'),
        width: '16px',
        height: '16px',
    },
    'media': {
        src: require('./img/media.svg'),
        width: '16px',
        height: '13px',
    },
    'media-folder': {
        src: require('./img/media-folder.svg'),
        width: '16px',
        height: '16px',
    },
    'media-folder-shared': {
        src: require('./img/media-folder-shared.svg'),
        width: '16px',
        height: '16px',
    },
    'media-move': {
        src: require('./img/media-move.svg'),
        width: '20px',
        height: '15px',
    },
    'minus': {
        src: require('./img/minus.svg'),
        width: '16px',
        height: '16px',
    },
    'minus-fill': {
        src: require('./img/minus-fill.svg'),
        width: '16px',
        height: '16px',
    },
    'move': {
        src: require('./img/move.svg'),
        width: '16px',
        height: '16px',
    },
    'owner-add': {
        src: require('./img/owner-add.svg'),
        width: '18px',
        height: '17px',
    },
    'owner-remove': {
        src: require('./img/owner-remove.svg'),
        width: '18px',
        height: '17px',
    },
    'owner-switch': {
        src: require('./img/owner-switch.svg'),
        width: '18px',
        height: '17px',
    },
    'pause': {
        src: require('./img/pause.svg'),
        width: '14px',
        height: '16px',
    },
    'play': {
        src: require('./img/play.svg'),
        width: '12px',
        height: '16px',
    },
    'playing-screen': {
        src: require('./img/playing-screen.svg'),
        width: '18px',
        height: '14px',
    },
    'playlist': {
        src: require('./img/playlist.svg'),
        width: '16px',
        height: '15px',
    },
    'plus': {
        src: require('./img/plus.svg'),
        width: '16px',
        height: '16px',
    },
    'plus-fill': {
        src: require('./img/plus-fill.svg'),
        width: '16px',
        height: '16px',
    },
    'preview': {
        src: require('./img/preview.svg'),
        width: '18px',
        height: '13.5px',
    },
    'refresh': {
        src: require('./img/refresh.svg'),
        width: '16px',
        height: '16px',
    },
    'redo': {
        src: require('./img/redo.svg'),
        width: '20px',
        height: '20px',
    },
    'remove-fill': {
        src: require('./img/remove-fill.svg'),
        width: '16px',
        height: '16px',
    },
    'search': {
        src: require('./img/search.svg'),
        width: '16px',
        height: '16px',
    },
    'settings': {
        src: require('./img/settings.svg'),
        width: '16px',
        height: '16px',
    },
    'screen': {
        src: require('./img/screen.svg'),
        width: '18px',
        height: '14px',
    },
    'screen-activate': {
        src: require('./img/screen-activate.svg'),
        width: '20px',
        height: '14px',
    },
    'screen-deactivate': {
        src: require('./img/screen-deactivate.svg'),
        width: '20px',
        height: '14px',
    },
    'screen-move': {
        src: require('./img/screen-move.svg'),
        width: '20px',
        height: '14px',
    },
    'screen-casting': {
        src: require('./img/screen-casting.svg'),
        width: '18px',
        height: '14px',
    },
    'schedule': {
        src: require('./img/schedule.svg'),
        width: '18px',
        height: '18px',
    },
    'shrink': {
        src: require('./img/shrink.svg'),
        width: '18px',
        height: '18px',
    },
    'spaces': {
        src: require('./img/spaces.svg'),
        width: '20px',
        height: '20px',
    },
    'splash': {
        src: require('./img/splash.svg'),
        width: '18px',
        height: '14px',
    },
    'splash-remove': {
        src: require('./img/splash-remove.svg'),
        width: '21px',
        height: '16px',
    },
    'share': {
        src: require('./img/share.svg'),
        width: '16px',
        height: '18px',
    },
    'shared': {
        src: require('./img/shared.svg'),
        width: '22px',
        height: '16px',
    },
    'skip-next': {
        src: require('./img/skip-next.svg'),
        width: '16px',
        height: '16px',
    },
    'skip-previous': {
        src: require('./img/skip-previous.svg'),
        width: '16px',
        height: '16px',
    },
    'star': {
        src: require('./img/star.svg'),
        width: '16px',
        height: '16px',
    },
    'stop': {
        src: require('./img/stop.svg'),
        width: '16px',
        height: '16px',
    },
    'switch': {
        src: require('./img/switch.svg'),
        width: '16px',
        height: '16px',
    },
    'tag': {
        src: require('./img/tag.svg'),
        width: '16px',
        height: '16px',
    },
    'template': {
        src: require('./img/template.svg'),
        width: '20px',
        height: '14px',
    },
    'themes': {
        src: require('./img/themes.svg'),
        width: '20px',
        height: '20px',
    },
    'theme-remove-default': {
        src: require('./img/theme-remove-default.svg'),
        width: '18px',
        height: '18px',
    },
    'trash': {
        src: require('./img/trash.svg'),
        width: '14px',
        height: '16px',
    },
    'undo': {
        src: require('./img/undo.svg'),
        width: '20px',
        height: '20px',
    },
    'upgrade': {
        src: require('./img/upgrade.svg'),
        width: '20px',
        height: '20px',
    },
    'unlock': {
        src: require('./img/unlock.svg'),
        width: '14px',
        height: '20px',
    },
    'video': {
        src: require('./img/video.svg'),
        width: '18px',
        height: '10px',
    },
    'view': {
        src: require('./img/view.svg'),
        width: '16px',
        height: '14px',
    },
    'warning': {
        src: require('./img/warning.svg'),
        width: '16px',
        height: '16px',
    },
    'website': {
        src: require('./img/website.svg'),
        width: '20px',
        height: '20px',
    },
    'checkbox-empty': {
        src: require('./img/checkbox-empty.svg'),
        width: '16px',
        height: '16px',
    },
    'checkbox-deselect': {
        src: require('./img/checkbox-deselect.svg'),
        width: '16px',
        height: '16px',
    },
    'checkbox-checked': {
        src: require('./img/checkbox-checked.svg'),
        width: '16px',
        height: '16px',
    },
    'screen-selected': {
        src: require('./img/screen-selected.svg'),
        width: '19px',
        height: '15px',
    },
};
//# sourceMappingURL=list.js.map